import { getWindowLocation } from './browser';
import { isBadSearchTerm } from './filter-tree';

/**
 * @type {import('./index.d').isTagPage}
 */
export const isTagPage = (tags) => {
  if (tags && tags.length > 0) return true;
  return false;
};

/**
 * @type {import('./index.d').isCollectionPage}
 */
export const isCollectionPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'collection';
  }

  return context?.app?.generalSettings?.page === 'collection';
};

/**
 * @type {import('./index.d').isSearchPage}
 */
export const isSearchPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'search';
  }

  return context?.app?.generalSettings?.page === 'search';
};

/**
 * @type {import('./index.d').isCartPage}
 */
export const isCartPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'cart';
  }

  return context?.app?.generalSettings?.page === 'cart';
};

/**
 * @type {import('./index.d').isProductPage}
 */
export const isProductPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'product';
  }

  return context?.app?.generalSettings?.page === 'product';
};

/**
 * @type {import('./index.d').isHomePage}
 */
export const isHomePage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'index';
  }

  return context?.app?.generalSettings?.page === 'index';
};

/**
 * @type {import('./index.d').isPageType}
 */
export const isPageType = () => {
  return window.location.pathname.indexOf('/collections/types') > -1 ? true : false;
};

/**
 * @type {import('./index.d').isVendorPage}
 */
export const isVendorPage = () => {
  return window.location.pathname.indexOf('/collections/vendors') > -1 ? true : false;
};

/**
 * Get current page
 * @type {import('./index.d').getCurrentPage}
 */
export const getCurrentPage = () => {
  let currentPage = '';

  switch (true) {
    case isCollectionPage():
      currentPage = 'collection_page';
      break;

    case isSearchPage():
      currentPage = 'search_page';
      break;

    case isProductPage():
      currentPage = 'product_page';
      break;

    case isCartPage():
      currentPage = 'cart_page';
      break;

    case isHomePage():
      currentPage = 'home_page';
      break;

    default:
      break;
  }

  return currentPage;
};

/**
 * @type {import('./index.d').isBadUrl}
 */
export const isBadUrl = (url) => {
  try {
    if (!url) {
      url = getWindowLocation().search;
    }
    var urlParams = decodeURIComponent(url).split('&');
    var isXSSUrl = false;
    if (urlParams.length > 0) {
      for (var i = 0; i < urlParams.length; i++) {
        var param = urlParams[i];
        isXSSUrl = isBadSearchTerm(param);
        if (isXSSUrl) break;
      }
    }
    return isXSSUrl;
  } catch {
    return true;
  }
};
